import React, { ComponentType } from 'react';

import { SegmentStatus, UserSegment } from 'api';
import { Queries } from 'components';

export interface IWithSegments {
  segments: UserSegment[];
}

const withSegments = (status = SegmentStatus.Active) => <T extends {}>(
  Component: ComponentType<T & IWithSegments>,
) => (props: T) => (
  <Queries.GetUserSegments status={status}>
    {segments => <Component {...props} segments={segments} />}
  </Queries.GetUserSegments>
);

export default withSegments;
